import PropTypes from 'prop-types';

import Reply from './reply';

export default PropTypes.shape({
  date: PropTypes.string,
  content: PropTypes.string,
  user: PropTypes.shape({
    avatarUrl: PropTypes.string,
    name: PropTypes.string,
  }),
  rating: PropTypes.number,
  replies: PropTypes.arrayOf(Reply),
}).isRequired;
